<!-- =========================================================================================
    File Name: KnowledgeBase.vue
    Description: Knowledge Base Page

========================================================================================== -->


<template>
  <div id="knowledge-base-page">
    <!-- JUMBOTRON -->
    <div class="rounded-lg w-full"
         style="background-image: url(https://cdn.discordapp.com/attachments/733851758211629347/954057924391600218/BG.png);
         box-shadow: 0px 4px 25px 0px rgba(0,0,0,.1);">
      <div class="knowledge-base-jumbotron-content lg:p-12 sm:p-10 p-8 rounded-lg mb-4"
           style="backdrop-filter: blur(10px); height: 100%;">
        <h5 class="font-light text-white">Course Selector</h5>
        <h1 class="mb-2 text-white font-bold" style="font-size: 2.9rem">Select a Course to Practice</h1>
        <vs-input v-model="courseSearch" placeholder="Search For Course" @input="filterCourses"
                  class="w-2/5" icon-pack="feather" icon="icon-search" icon-no-border></vs-input>
      </div>
    </div>

    <!-- COURSE SELECT CARDS  -->
    <div v-if="coursesLoaded">
      <slide-x-left-transition group class="vx-row match-height" tag="div">
        <div v-for="item in coursesFiltered" v-if="item.id" :key="item.id" class="vx-col card-width-course mb-base">
          <course-selector-card :item="item"/>
        </div>
      </slide-x-left-transition>
      <h1 v-if="courseSearch !== '' && !coursesFiltered.length">No Courses Found</h1>
    </div>
    <div v-if="!coursesLoaded && !coursesNone && coursesTotal.length === 0" class="simple-spinner">
      <span></span>
    </div>
    <h1 v-if="coursesNone" class="font-bold">You Are Not Subscribed To Any Courses</h1>
  </div>
</template>

<!--suppress ES6ShorthandObjectProperty -->
<script>
import CourseSelectorCard from './components/CourseSelectorCard'

export default {
  data () {
    return {
      courseSearch: '',
      coursesTotal: [],
      coursesFiltered: [],
      coursesLoaded: false,
      coursesNone: false
    }
  },
  computed: {
    activeCourseInfo () {
      return this.$store.state.AppActiveCourse
    }
  },
  methods: {
    fetchSubscribedCourses () {
      this.$http.get('users/@me/subscriptions')
        .then(subscriptions => {


          if (subscriptions.data.data.length === 0) {
            this.coursesNone = true
            // location.replace('https://www.youtube.com/watch?v=jE2VvGZktJo')
          }

          subscriptions.data.data.forEach(x => {
            this.$http.get(`courses/${x.course_id}`)
              .then(async response => {
                if (response.status === 200 && response.data.data.status === 'active') {
                  if (!this.activeCourseInfo.selected) {
                    this.coursesTotal.push(response.data.data)
                  }
                  if (this.activeCourseInfo.selected && this.activeCourseInfo.id !== response.data.data.id) {
                    this.coursesTotal.push(response.data.data)
                  }
                }
              })
          })

          if (this.activeCourseInfo && this.activeCourseInfo.selected !== false) {
            this.coursesTotal.push(this.activeCourseInfo)
          }

          this.coursesTotal.sort((a, b) => a.name.localeCompare(b.name))
          this.coursesFiltered = this.coursesTotal

        }).finally(() => {
          this.coursesLoaded = true
        })
    },
    filterCourses () {
      this.coursesFiltered = this.coursesTotal.filter((course) => {
        return course.name.toLowerCase().includes(this.courseSearch.toLowerCase().trim())
      })
    }
  },
  beforeDestroy () {
    this.coursesTotal = null
  },
  beforeMount () {
    this.fetchSubscribedCourses()
  },
  components: {
    CourseSelectorCard
  }
}
</script>
<style lang="scss">

.card-width-course {
  width: 20%;
}

@media (max-width: 2200px) {
  .card-width-course {
    width: 25%;
  }
}

@media (max-width: 1800px) {
  .card-width-course {
    width: 33.333333%;
  }
}

@media (max-width: 1300px) {
  .card-width-course {
    width: 50%;
  }
}

@media (max-width: 750px) {
  .card-width-course {
    width: 100%;
  }
}
</style>

